import { Translation } from '@shared/types/translation';

export const QMS_CATEGORY_LABELS = {
  TAG_HELPER: {
    english: 'Enter tags separated by commas (e.g., Safety, HR, Policy).',
    polish: 'Wprowadź tagi oddzielone przecinkami (np. BHP, HR, Polityka).',
  },
  TAB_QMS_DOCUMENTS: {
    english: 'QMS Documents',
    polish: 'Dokumenty QMS',
  },
  QMS_DOCUMENTS_EMPTY: {
    english: 'No QMS documents associated with this category.',
    polish: 'Brak dokumentów QMS powiązanych z tą kategorią.',
  },
} as const satisfies Record<string, Translation>;
